import {useAuth0} from "@auth0/auth0-react"
import Cookies from "js-cookie"
import React, {useEffect, useState} from "react"

import ChatPage from "@/components/ui/ChatPage"
import Loading from "@/components/ui/Loading"
import Login from "@/components/ui/Login"
import {AUTH0_AUDIENCE} from "@/constants"

const TOKEN_COOKIE_KEY = "BotBearer"

const AuthenticatedApp: React.FC = () => {
    const {isAuthenticated, isLoading, getAccessTokenSilently} = useAuth0()
    const [cookieReady, setcookieReady] = useState<boolean>(false)

    useEffect(() => {
        const setAuthTokenCookie = async () => {
            try {
                const accessToken = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: AUTH0_AUDIENCE,
                    },
                })
                Cookies.set(TOKEN_COOKIE_KEY, accessToken, {expires: 7, secure: true})
                setcookieReady(true)
            } catch (e) {
                console.log(e)
            }
        }

        if (isAuthenticated) {
            setAuthTokenCookie()
        }
    }, [getAccessTokenSilently, isAuthenticated])

    if (cookieReady) {
        return <ChatPage />
    }

    if (isLoading || (isAuthenticated && !cookieReady)) {
        return <Loading />
    }

    return <Login />
}

export default AuthenticatedApp
